import { getActions, getReducers, getTypes } from '../initializers';

// user get state
const identifier = 'USER_GET';

export const getUserGetState = (state) => state.user?.userGet;

export const types = getTypes(identifier);
export const actions = getActions(
  identifier,
  (params) => (params && params.id ? `users/${params.id}` : 'users/me')
);
const reducer = getReducers(identifier);

export default reducer;
